export enum AlertIcon {
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  REFRESH = 'REFRESH',
}

export interface Alert {
  id?: string;
  message: string;
  autoHideDuration?: number | null;
  statusIcon?: AlertIcon;
}
